"use client";

import { useState, useRef, useCallback } from "react";
import { Stack, Typography } from "@mui/material";
import { UploadCard } from "@/ui";
import useCVUpload from "@lib/candidates/useCVUpload";
import useImportingStatus from "@lib/candidates/useImportingStatus";
import { useJobStatus } from "@lib/jobs/useJobStatus";
import slugify from "@lib/helpers/slugify";
import { JobStatus } from "@lib/enums";
import config from "@lib/config";

const QuickWinIcon = () => (
  <svg viewBox="0 -1 24 25" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="11" height="11" aria-hidden="true">
    <path d="M15 14c.2-1 .7-1.7 1.5-2.5C17.9 10.1 19 8.7 19 7a7 7 0 10-14 0c0 1.7 1.1 3.1 2.5 4.5.8.8 1.3 1.5 1.5 2.5"/>
    <path d="M9 18h6"/>
    <path d="M10 22h4"/>
  </svg>
);

export default function CVUpload() {
  const inputRef = useRef(null);
  const { addJob } = useJobStatus();
  const upload = useCVUpload();

  const handleImportComplete = () => {};
  const { queued, importing } = useImportingStatus(handleImportComplete);

  const processFiles = useCallback((files) => {
    Array.from(files).forEach((file) => {
      addJob(slugify(file.name), { status: JobStatus.QUEUED });
      upload.mutate({ file, fileId: slugify(file.name) });
    });
  }, [addJob, upload]);

  const handleFileDrop = (files) => processFiles(files);

  const handleBrowseClick = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.click();
    }
  };

  return (
    <Stack spacing={2}>
      <Typography variant="h2">Add new candidates to float</Typography>
      <input
        ref={inputRef}
        type="file"
        style={{ display: "none" }}
        accept=".pdf,.doc,.docx"
        multiple={config.maxFileUpload > 1}
        onChange={(e) => {
          if (e.target.files?.length > 0) processFiles(e.target.files);
        }}
      />
      <UploadCard
        heading="Add new candidates"
        onFileDrop={handleFileDrop}
        onBrowseClick={handleBrowseClick}
        tip={{
          header: 'QUICK WIN',
          icon: <QuickWinIcon />,
          content: 'Upload up to 5 CVs at the same time and add them instantly to your float to send to your network .. all in a matter of minutes!',
        }}
      />
    </Stack>
  );
}
